import { getAxios } from '../../../../lib/axios';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { useQuery } from '@tanstack/react-query';
import { PhoneNumberModel } from '../../../../globalModels/common/phoneNumberModel';
import { EntityNoteModel } from '../../../../globalModels/entityNotes/entityNoteModel';
import { EmailAddressModel } from '../../../../globalModels/common/emailAddressModel';

export type ActivityInformationTravellerModel = {
  Id: number;
  ToBeVerified: boolean;
  BranchOffice: string | undefined;
  PhoneNumbers: PhoneNumberModel[];
  Email: string | undefined;
  FirstName: string;
  LastName: string;
  IsVip: boolean;
  EmailAddresses: EmailAddressModel[];
  PersonalEmail: string | undefined;
  PersonalPhone: string | undefined;

  Title: string | undefined;
  CodeRedNotes: EntityNoteModel[];
  AgentNotes: EntityNoteModel[];
  HasObtAccess: boolean;
  IsObtSuperUser: boolean;
  IsObtAuthBooker: boolean;
  IsCompanyDisabled: boolean;
  IsDisabled: boolean;
  IsAuthorizedBooker: boolean;
  PersonalPreferences: string | undefined;
  GdsCardLastFour: string | undefined;
  PersonalGdsCardLastFour: string | undefined;
  CompanyName: string;
  PreferredPaymentMethods: string[];
  Tags: string[];
  BookingAuthInstructions: string | undefined;
  LoyaltyNumbers: {
    Type: string;
    AccountNumber: string;
  }[];
};

export function useActivityInformationTravellersQuery(travellerIds: number[]) {
  return useQuery<ActivityInformationTravellerModel[]>({
    queryKey: [ActivityEndpoints.information.travellers(travellerIds)],
    enabled: travellerIds != undefined && travellerIds?.length != 0,
    queryFn: async () => (await getAxios().get(`${ActivityEndpoints.information.travellers(travellerIds)}`)).data
  });
}
